import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import CommonContainer from '../containers/Common';
import Console from './console/Index';
import Users from './users/Index';

const App: React.FC = () => {
  return (
    <Router>
      <CommonContainer.Provider>
        <Switch>
          <Route path="/console" component={Console} />
          <Route path="/users" component={Users} />
        </Switch>
      </CommonContainer.Provider>
    </Router>
  );
}

export default App;
